import Grid from '@material-ui/core/Grid';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';

import Snackbar from '../../components/snackbar';
import List from '../listCost';
import { styles } from './style';
import Loading from '../loading';
import Header from '../../partials/header' 
// import SearchIcon from '@material-ui/icons/Search';
// import InputBase from '@material-ui/core/InputBase';

let id = -1;
function createData(isSystem, name, value) {
  return {isSystem, name, value };
} 
const rows = [createData(1, "electrict_cost", 0), createData(1, "water_cost", 0), createData(1, "internet_cost", 0), createData(1, "space_cost", 0), createData(1, "clean_cost", 0)];

class StableCost extends Component {
    constructor(props) {
        super(props);
        this.state = {
            rows: []
        } 
        this.t = this.props.t 

    }
    componentDidMount(){
      this.getStableCost()
    }
    getStableCost = async() => {
      this.loading.startLoading()
      let check = await this.props.getStableCost() 
      this.loading.stopLoading()
      if(check.code === 1)
        this.list.changeState({'rows': check.data.length ? [...check.data[0].serviceCost] : [...rows] }) 
      else this.mSnackbar.handleClick(check.message ,'error')
    }
    //  shouldComponentUpdate(nextProps, nextState) {
    //     if (nextState !== this.state) {
    //         return true;
    //     }
    //     return false;
    // }
    
    addNewCost = (status) => {
        const _this = this
        this.list.changeState({'isAddNew': status})
    }   
    handleSaveChange = async(payload) => {
      this.loading.startLoading()
      let check = await this.props.updateStableCost({serviceCost: payload.rows})
      this.loading.stopLoading() 
      if(check.code === 1) {
        this.list.changeState({'rows': payload.rows, isAddNew: false, flagEdit: false})
        this.mSnackbar.handleClick(this.t('service_table_cost_update_service_cost_successfully'))
      }
      else this.mSnackbar.handleClick(this.t('service_table_cost_update_service_cost_unsuccessfully')+' '+check.message,'error')
    } 
    render() { 
        const { classes, t } = this.props;
        return (
        <div>
            <Loading onRef={id => (this.loading = id)}/>
            <Snackbar
                color='white'
                onRef={snackbar => (this.mSnackbar = snackbar)} 
            /> 
            <Header
                session= {t('sidebar_manage')}
                title= {t('service_table_cost')} 
                // button= {t('service_cost_add_new')}
                // actionButton= {()=>this.addNewCost(true)}
            />
            <List title= {t('service_table_cost')} onRef={id => (this.list = id)} handleSaveChange = {this.handleSaveChange} tyleList = 'stableCost'/>
        </div>
        );
    }
}

StableCost.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired
};

const mapState = state => ({});

const mapDispatch = dispatch => ({
    updateStableCost: dispatch.stableCost.updateStableCost,
    getStableCost: dispatch.stableCost.getStableCost
});


export default connect( mapState, mapDispatch)( translate("translations")(withStyles(styles, { withTheme: true })(StableCost))
);
